import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GoogleOAuthProvider } from '@react-oauth/google';

// --- GOOGLE_CLIENT_ID GÜNCELLEMESİ ---
// Değişken, Backend .env dosyasındaki yeni GOOGLE_CLIENT_ID ile senkronize edildi.
// Yeni ID: 178954887274-h2fdu0l0348eqmhjag3otsr5abfrs1ek.apps.googleusercontent.com
const GOOGLE_CLIENT_ID = "178954887274-h2fdu0l0348eqmhjag3otsr5abfrs1ek.apps.googleusercontent.com";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
       <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);